<template>
  <Card :title="$t('global.application')" :logo="getType()" :height100="false">
    <CardActionContent :buttons="getButtons()">
      <template #description>
        <LoadingState v-if="status.isLoading" />
        <CardListContent v-else :list="getList()" />
      </template>
    </CardActionContent>
    <template v-if="isWpOrWoo()">
      <hr />
      <PluginUpgrades :resource-name="resourceName" :site="site" />
      <CoreUpgrades :resource-name="resourceName" :site="site" />
    </template>
  </Card>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import Card from "@/components/display/Card";
import CardActionContent from "@/components/display/card-sub-components/CardActionContent";
import CardListContent from "@/components/display/card-sub-components/CardListContent";
import CoreUpgrades from "@/components/smart/cards/CoreUpgrades";
import LoadingState from "@/components/display/LoadingState";
import NavLink from "@/classes/NavLink";
import PluginUpgrades from "@/components/smart/cards/PluginUpgrades";
import store from "@/store";
import ViewPassword from "@/components/smart/modals/ViewPassword";

export default {
  name: "Application",
  components: {
    Card,
    CardActionContent,
    CardListContent,
    CoreUpgrades,
    PluginUpgrades,
    LoadingState,
  },
  props: {
    resourceName: {
      type: String,
      required: true,
    },
    site: Object,
  },
  setup(props, { root }) {
    const password = computed(() => store.getters["password/getSiteApp"]);
    const status = computed(() => store.getters["password/getSiteAppStatus"]);

    const goToAdmin = () => window.open(getUrl(), "_blank");

    const getButtons = () => {
      return [new NavLink(root.$t("global.admin"), null, goToAdmin, false, "primary", null)];
    };

    const getList = () => {
      const list = [
        {
          label: root.$t("global.username"),
          content: getUsername(),
          canCopy: true,
        },
      ];

      if ((status.value.isLoaded || status.value.isUpdating) && hasRemainingViews()) {
        list.push({
          label: root.$t("global.password"),
          content: root.$t("global.password-hidden"),
          actions: [
            new NavLink(
              root.$t("global.view-password"),
              "view",
              viewPassword,
              false,
              null,
              "epsilon"
            ),
          ],
        });
      }

      return list;
    };

    const getType = () => props.site.app.type;
    const getUrl = () => props.site.environment.access.url;
    const getUsername = () => props.site.environment.access.username;

    const hasRemainingViews = () => (password.value?.maxViews || 0) > (password.value?.views || 0);

    const isLoading = () => status.value.isLoading;
    const isErrored = () => status.value.isErrored;
    const isWpOrWoo = () => ["wordpress", "woocommerce"].includes(props.site?.app?.type);

    const viewPassword = () => {
      store.dispatch("modals/open", {
        template: ViewPassword,
        data: { password: password.value },
      });
    };

    onMounted(() => {
      store.dispatch("password/getSiteApp", props.site.id);
    });

    return {
      getButtons,
      getList,
      getType,
      getUrl,
      isLoading,
      isErrored,
      isWpOrWoo,
      status,
    };
  },
};
</script>
